import { IProductFilter } from '../../constants/product/productFilter.constant';

interface IResetProductFilterOptionIsSelectedParams {
  currentFilters: IProductFilter[];
  targetFilter?: IProductFilter;
}

export const resetProductFilterOptionIsSelected = ({
  currentFilters,
  targetFilter,
}: IResetProductFilterOptionIsSelectedParams): IProductFilter[] => {
  const newProductFilters = currentFilters.map((filter) => {
    // 타겟 필터가 없는 경우 => 전체 필터 초기화
    // 타켓 필터가 있는 경우 => 타겟 필터만 초기화
    if (!targetFilter || (targetFilter && targetFilter.key === filter.key)) {
      const newOptions = filter.options.map((option) => {
        if (option.isDefault) {
          option.isSelected = true;
        } else {
          option.isSelected = false;
        }
        return option;
      });
      return { ...filter, options: newOptions };
    }

    return filter;
  });

  return newProductFilters;
};
